module.exports = __webpack_public_path__ + "static/media/TPT-BUSD.fecda73d.svg";